import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './PoleBeansPage.css';
import polebeansLogo from '../images/polebeans-logo.png';

const varieties = [

];

export default function PoleBeansPage() {
  return <ProductPatternPage title="Pole Beans" 
  varieties={varieties} 
  pageClass="polebeans-page" 
  heroImage={polebeansLogo} />;
}
